import Vue from 'vue'
import Router from 'vue-router'
import { Dialog } from 'vant'
import { getThirdPartyPlatformCode } from "../api/haidian";
// import { getToken } from '../utils/auth'
Vue.use(Router)

import home from './modules/home'
import haidianHome from './modules/haidianHome'
import premanage from './modules/premanage'
import news from './modules/news'
import waitPre from './modules/waitpre'
import preClose from './modules/preclose'
import adProfit from './modules/adprofit'
import adProfitList from './modules/adprofitlist'
import adCouponInfo from './modules/adcouponinfo'

import waitprenews from './modules/waitprenews'

import mine from './modules/mine'
import resetPassword from './modules/resetPassword'
import aboutUs from './modules/aboutUs'
import login from './modules/login'
import advertisement from './modules/advertisement'
import agreement from './modules/agreement'
import interrogationInfoText from './modules/interrogationInfoText'
import prescription from './modules/prescription'
import prescriptionImg from './modules/prescription-img'
import service from './modules/service'
import serviceagreement from './modules/serviceagreement'
import adUrl from './modules/adUrl'
import padIndex from '@/view/padIndex'
import course from './modules/course'
import qualificationImage from './modules/qualificationImage'
import cancelAccount from './modules/cancelAccount'
import allergySelect from './modules/allergySelect'
import intercept from "./modules/intercept"
import distanceLimit from './modules/distanceLimit'
import askDockerChat from './modules/askDockerChat'

const routes = [{
        path: '*',
        redirect: '/home'
    },
    {
        name: 'padIndex',
        component: padIndex,
        meta: {
            title: 'padIndex'
        }
    },
    home,
    haidianHome,
    premanage,
    news,
    waitPre,
    preClose,
    waitprenews,
    mine,
    resetPassword,
    aboutUs,
    login,
    advertisement,
    agreement,
    adProfit,
    adProfitList,
    adCouponInfo,
    interrogationInfoText,
    prescription,
    prescriptionImg,
    service,
    serviceagreement,
    adUrl,
    course,
    qualificationImage,
    cancelAccount,
    allergySelect,
    intercept,
    askDockerChat,
    ...distanceLimit    // 离店限制相关
]

// add route path
routes.forEach(route => {
    route.path = route.path || '/' + (route.name || '')
})

const router = new Router({
    mode: 'history',
    routes,
    // base: '/patient',
    base: process.env.NODE_ENV === 'development' ? '/' : '/patient',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {
                x: 0,
                y: -20
            }
        }
    }
})

router.beforeEach(async (to, from, next) => {
    console.log('----bug ....................');
    console.log(to.name);
    console.log(from.name);
    if (to.name === 'home') {
        console.log('----bug haihaihaihaiahi');
        // 是否展示海典首页
            try {
                let res = await getThirdPartyPlatformCode()
                if (res.code == 0 && res.result.thirdPartyPlatformCode != undefined && res.result.thirdPartyPlatformCode != '') {
                    next({ path: '/haidianHome', query: { ...to.query } });
                }else {
                    next()
                }
            } catch (error) {
                next()
            }
    }
    const title = to.meta && to.meta.title
        // const token = getToken() // 新加
    if (title) {
        document.title = title
    }
    if (from.name === 'prescription') {
        Dialog.close();
    }
    setTimeout(() => {
        next()
    }, 100)
})

// router.beforeEach((to, from, next) => {
//   const token = getToken()
//   if (token) {
//     next()
//   } else {
//     next({ path: '/home' })
//   }
// })

export default router